/**
 * Launch Phase Feature Flag
 *
 * Controls whether the site shows founding partner / early access messaging
 * or full purchase-oriented CTAs with pricing.
 *
 * Set NEXT_PUBLIC_LAUNCH_PHASE=launched to enable purchase mode.
 * Defaults to 'founding' (early access mode).
 */

export type LaunchPhase = 'founding' | 'launched';

export function getLaunchPhase(): LaunchPhase {
  const value = process.env.NEXT_PUBLIC_LAUNCH_PHASE;
  if (value === 'launched') return 'launched';
  return 'founding';
}

export function isFoundingPartnerPhase(): boolean {
  return getLaunchPhase() === 'founding';
}
